import Api from '@/common/api';

const apiIRS = Api.getApiIRS();

export async function requestGetChannels() {
  const { data, metadata } = await apiIRS.request('get', `/channels`, {});
  return { data, metadata };
}
